module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vc-day-popover-row"
  }, [(_vm.indicator) ? _c('div', {
    staticClass: "vc-day-popover-row-indicator"
  }, [_c('span', {
    class: _vm.indicator.class,
    style: (_vm.indicator.style)
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vc-day-popover-row-content"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.attribute.popover ? _vm.attribute.popover.label : 'No content provided'))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57141405!./~/vue-loader/lib/selector.js?type=template&index=0!./~/v-calendar/src/components/PopoverRow.vue
// module id = 1394
// module chunks = 94